import styled, { css } from 'styled-components'

export const PaletteWrap = styled.div`
  margin-bottom: 17px;
  position: relative;
  max-height: 42px;

  ${(p) =>
    !p.withBackground &&
    css`
      margin-bottom: 0;
      max-height: none;
    `}
`

export const ButtonOpen = styled.button`
  display: block;
  cursor: pointer;

  ${(p) =>
    p.withBackground &&
    css`
      height: 42px;
      border-radius: 8px;
      padding: 0 16px;
      border: 1px solid var(--t-surface-2);
      background-color: var(--t-surface-2);
    `}

  ${(p) =>
    !p.withBackground &&
    css`
      margin-bottom: 0;
    `}

  transition: all 0.3s;

  ${(p) =>
    p.color &&
    css`
      &::before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background-color: ${(p) => p.color};

      ${(p) =>
        !p.withBackground &&
        css`
          border-radius: 4px;
        `}
      `}
  }

  ${(p) =>
    !p.color &&
    css`
      &::before {
        content: 'X';
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border: 1px solid var(--t-palette-button-open-color);
        box-sizing: border-box;
        font-weight: bold;
        font-size: 16px;
        line-height: 1;
        color: var(--t-palette-button-open-color);
      }
    `}
  }

  &:hover {
    border-color: var(--t-input-hover);
  }
`

export const PaletteSection = styled.div`
  position: absolute;
  background-color: var(--t-surface-block);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(8, 20px);
  gap: 10px;
  top: 50px;
  left: -72px;
  z-index: 10;

  ${(p) =>
    !p.withBackground &&
    css`
      left: 25px;
      top: -25px;
    `}
`
